// getModuleColumnsReducer
import { createSlice } from "@reduxjs/toolkit";
import getModuleColumns from "../../actions/admin/getModuleColumns";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const getModuleColumnsReducer = createSlice({
  name: "getModuleColumnsReducer",
  initialState,
  reducers: {
    // cleargetUsersState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getModuleColumns.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getModuleColumns.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getModuleColumns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export const { cleargetUsersState } = getUsersSlice.actions;
export default getModuleColumnsReducer.reducer;
